<template>
  <div class="t-dialogList">
    <div class="t-dialogList__create t-btn t-btn_white t-btn_full" @click="modalDialogType_dialogCreateNew()">
      <span>
        {{dialogText.createChat}}
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C8 0.447715 7.55228 0 7 0C6.44772 0 6 0.447715 6 1V6H1C0.447715 6 0 6.44772 0 7C0 7.55228 0.447715 8 1 8H6V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H8V1Z" fill="#52A8F2"></path>
        </svg>
      </span>
    </div>
    <div class="t-dialogList__wrapper">
      <v-bar v-if="!mobileState" wrapper="t-dialogList__scroll">
        <div class="t-dialogList__content">
          <div class="t-dialogList-content__wrapper">
            <router-link :to="{name: 'dialog', query: {'sel': item.id}}"
                        class="t-dialogItem"
                        :class="{'t-dialogItem_admin' :item.isAdmin}"
                        v-for="(item, index) in dialogList"
                        :key="'dialog_' + index">
              <div v-if="item.new" class="t-dialogItem__new"></div>
              <div class="t-dialogItem__img">
                <img v-if="item.img !== ''" :src="item.img">
                <img v-else-if="item.isGroup" src="/img/default_img_group.png">
                <img v-else-if="item.isAdmin" src="/img/default_img_support.png">
                <img v-else src="/img/default_img.png">
              </div>
              <div class="t-dialogItem__name" :class="{ _blue: item.online || item.isAdmin}">{{ !item.isAdmin ? item.name : dialogText.supportName }}</div>
              <div class="t-dialogItem__date">{{ item.lastActiveDate }}</div>
            </router-link>
          </div>
        </div>
      </v-bar>
      <div v-else class="t-dialogList__content">
        <router-link :to="{name: 'dialog', query: {'sel': item.id}}"
                    class="t-dialogItem"
                    :class="{'t-dialogItem__admin' :item.isAdmin}"
                    v-for="(item, index) in dialogList"
                    :key="'dialog_' + index">
          <div v-if="item.new" class="t-dialogItem__new"></div>
          <div class="t-dialogItem__img">
            <img v-if="item.img !== ''" :src="item.img">
            <img v-else-if="item.isGroup" src="/img/default_img_group.png">
            <img v-else-if="item.isAdmin" src="/img/default_img_support.png">
            <img v-else src="/img/default_img.png">
          </div>
              <div class="t-dialogItem__name" :class="{ _blue: item.online || item.isAdmin}">{{ !item.isAdmin ? item.name : dialogText.supportName }}</div>
          <div class="t-dialogItem__date">{{ item.lastActiveDate }}</div>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import VBar from 'v-bar'

    export  default {
        components: {
            VBar
        },
        computed: {
            ...mapGetters('staticText', ['dialogText']),
            ...mapGetters('dialog', ['dialogList']),
            ...mapGetters(['mobileState'])
        },
        methods: {
          ...mapActions('modal', ['modalDialogType_dialogCreateNew'])
        },
    }
</script>

<style lang="sass">
.t-dialogList
  width: 320px
  margin-right: 24px
  &__create
    margin-bottom: 8px
    svg
      margin-left: 20px !important
    span
      padding: 4px
      display: flex
      align-items: center
      justify-content: center
  &__wrapper
    @extend %substrate
    position: relative
  &__scroll
    .bar--container
      max-height: calc(100vh - 200px)
    .bar--wrapper
      position: relative
      height: auto
      max-height: calc(100vh - 176px - 80px)
    .bar--vertical
      width: 1px
      background: $disabled
      margin-top: 16px
      margin-bottom: 16px
      height: calc(100% - 32px)
      margin-right: 10px
    .bar--vertical-internal
      opacity: 1
      background: $blue
  &__content
    margin-bottom: -24px
.t-dialogList-content__wrapper
  padding: 16px
  display: flex
  flex-direction: column
  width: 100%
.t-dialogItem
  width: 100%
  padding: 12px 8px
  border-radius: 8px
  cursor: pointer
  display: flex
  align-items: center
  position: relative
  &__new
    position: absolute
    top: 5px
    left: 0
    width: 20px
    height: 20px
    border-radius: 50%
    background: $accented
  &__img
    width: 50px
    height: 50px
    border-radius: 8px
    overflow: hidden
    margin-right: 12px
    flex: none
    img
      width: 100%
      height: 100%
      object-fit: cover
  &__name
    font-size: 14px
    font-weight: bold
    line-height: 1.2
    flex: 1
    &._blue
      color: $blue
  &__date
    flex: none
    line-height: 1.2
    font-size: 12px
    align-self: flex-start
  &.router-link-exact-active
    background: $promo
    + .t-dialogItem:before
      content: none
      display: none
  &_admin
    order: -1
    background: $input
    &.router-link-exact-active
      background: $blue
      color: #ffffff
      .t-dialogItem__name
        color: #ffffff
      + .t-dialogItem:before
        content: none
        display: none
  &:not(.router-link-exact-active):not(:first-child)
    &:before
      content: ''
      position: absolute
      top: 0
      left: 8px
      right: 8px
      height: 1px
      background: $input

@media (max-width: 769px)
  .t-dialogList
    margin: 0
    width: 100%
    &__content
      margin-bottom: 0
      padding: 16px
      display: flex
      flex-direction: column

</style>


// WEBPACK FOOTER //
// src/vue_components/Dialog/DialogList.vue